export default "__VITE_ASSET__35be4eb6__"